export type IgnoreRow = {
  slug: string;
  owner: string;
  id: string;
  path: string;
  reason: string;
  expires?: string;
  created?: string;
  author?: string;
  addedAt?: string;
  line?: number;
};
export type Status = 'vencida' | 'por-vencer' | 'sin-vencimiento' | 'vigente';

export const WARN_DAYS = 15;

/** Vencida, vence en menos de 15 días, sin fecha de vencimiento o vigente. */
export function statusOf(row: Pick<IgnoreRow, 'expires'>, now = Date.now()): Status {
  const at = row.expires ? Date.parse(row.expires) : NaN;
  if (Number.isNaN(at)) return 'sin-vencimiento';
  if (at <= now) return 'vencida';
  return at - now < WARN_DAYS * 86_400_000 ? 'por-vencer' : 'vigente';
}

export const STATUS_TEXT: Record<Status, string> = {
  vencida: 'Vencida',
  'por-vencer': `Vence en < ${WARN_DAYS} días`,
  'sin-vencimiento': 'Sin vencimiento',
  vigente: 'Vigente',
};
